/* BB HOME — winners rail, sticky bar, and dark-card conversion for
   native product-blocks. Countdown is handled globally by bb-timer.js
   (single 48h source) so there is no timer logic here anymore. */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-index')) return;

  var home = document.querySelector('.bb-home');

  /* ---------- winners rail ---------- */
  if (home) {
    var track = home.querySelector('.bb-rail-track');
    if (track) {
      home.querySelectorAll('.bb-rail-arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.querySelector('.bb-winner-card');
          var step = card ? card.getBoundingClientRect().width + 14 : 240;
          track.scrollBy({ left: btn.getAttribute('data-bb-dir') === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    }
  }

  /* ---------- sticky bar: show after hero scrolls off ---------- */
  var sticky = home && home.querySelector('.bb-sticky');
  if (sticky) {
    var hero = document.querySelector('.slideshow, [id^="shopify-section-"] .slick-slider, .banner-slideshow')
           || document.querySelector('main [id^="shopify-section-"]');
    if (hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(hero);
    } else {
      window.addEventListener('scroll', function () {
        sticky.classList.toggle('is-visible', window.scrollY > 600);
      }, { passive: true });
    }
  }

  /* ---------- dark-ify native product-blocks + inject pills ---------- */
  var dataEl = document.getElementById('bb-home-pill-data');
  var PILLS = {};
  if (dataEl) { try { PILLS = JSON.parse(dataEl.textContent) || {}; } catch (e) {} }

  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function buildPills(info) {
    var wrap = document.createElement('div');
    wrap.className = 'bb-card-pills';
    if (info.entries && info.entries > 0) {
      var e = document.createElement('span');
      e.className = 'bb-entries-pill';
      e.innerHTML = '<span class="bb-ticket" aria-hidden="true">\uD83C\uDF9F</span>' + fmt(info.entries) + ' Entries';
      wrap.appendChild(e);
    }
    if (info.mult) {
      var m = document.createElement('span');
      m.className = 'bb-mult-pill';
      m.innerHTML = '<span>' + info.mult + '</span>';
      wrap.appendChild(m);
    }
    return wrap.children.length ? wrap : null;
  }

  function decorate() {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (section) {
      var isProductBlock = section.querySelector('.product-block, .products-block, .product-block__grid, .productBlock');
      if (!isProductBlock) return;
      section.classList.add('bb-dark-block');
      section.querySelectorAll('.product-item[data-product-id]').forEach(function (card) {
        if (card.querySelector('.bb-card-pills')) return;
        var info = PILLS[card.getAttribute('data-product-id')];
        if (!info) return;
        var pills = buildPills(info);
        if (!pills) return;
        var anchor = card.querySelector('.card-media') || card.querySelector('.card-product__wrapper');
        if (anchor) anchor.appendChild(pills);
      });
    });
  }
  decorate();

  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; decorate(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
